import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import {Table, TableCell, TableRow, TableHead} from 'react-toolbox/lib/table'
import { getTranslationKey } from 'containers/Greenlight/utils'
import { EXCLUDED_SPECS } from 'containers/Greenlight/TestReport/constants'
import T from 'i18n-react'
import * as R from 'ramda'
import { POWER_KEYS } from '../../constants'

const tableHeadContent = {
    parameter: (<TableCell key={0}>&nbsp;</TableCell>),
    min: (<TableCell key={1}>&nbsp;</TableCell>),
    max: (<TableCell key={2}>&nbsp;</TableCell>),
    avg: (<TableCell key={3}>&nbsp;</TableCell>),
}

const getTableHead = (tableHeadContent) =>  (
    <TableHead>
        {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
)

const getViewTableRows = (source, tableHeadContent) => {
    const mapIndexed = R.addIndex(R.map);
    return(
        mapIndexed((rowContent, idx) => (
            <TableRow key={idx}>
                {mapIndexed((key, idx) => (
                    <TableCell key={idx}>{(rowContent && rowContent[key]) ? rowContent[key] : ""}</TableCell>
                ), R.keys(tableHeadContent))}
            </TableRow>
        ), source)
    )
}

const prettify = (name, value) => {
    if(value != null && !isNaN(value)){
        return value + ' ' + T.translate(`testReport.dataTableValues.${name}.unit`)
    } else {
        return 'N/A'
    }
}

const renderRows = (data) => {
    var i = 0
    var rows = []
    const includedData = R.compose(
        R.fromPairs,
        R.reject(R.compose(
            R.contains(R.__, EXCLUDED_SPECS),
            R.prop(0)
        )),
        R.toPairs
    )(data)
    for(var key in includedData){
        includedData[key].forEach((dataObject, index) => {
            let prefix = '',
                translationKey = getTranslationKey(key),
                parameter = T.translate(`testReport.dataTableValues.${translationKey}.name`)
            if (POWER_KEYS.includes(key)) {
                if (dataObject.min > 1000) {
                    dataObject.min = parseFloat(dataObject.min/1000).toFixed(1)
                    dataObject.max = parseFloat(dataObject.max/1000).toFixed(1)
                    dataObject.avg = parseFloat(dataObject.avg/1000).toFixed(1)
                }
            }
            if (includedData[key].length > 1)
              prefix = T.translate('testReport.dataTablePrefix', {gpuNumber: index + 1})
            const rowProps = {
              min: prettify(translationKey, dataObject.min),
              max: prettify(translationKey, dataObject.max),
              avg: prettify(translationKey, dataObject.avg),
              parameter: `${prefix}${parameter}`
            }
            rows.push(rowProps)
            i++
        })
    }
    return rows
}

const DataTable = (props) => {
    return(
        <div className="tableContainer" style={{overflow: 'auto'}}>
            <Table theme={styles} selectable={false}>
                {getTableHead(tableHeadContent)}
                {getViewTableRows(renderRows(props.data), tableHeadContent)}
            </Table>
        </div>
    )
}

export default CSSModules(styles)(DataTable)
